(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-configurator"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const builder = document.querySelector('[data-canopy-builder]');
  if (!builder) return;

  const sizeInput = builder.querySelector('[data-builder-size]');
  const wallsInput = builder.querySelector('[data-builder-walls]');
  const artworkInput = builder.querySelector('[data-builder-artwork]');
  const priceEl = builder.querySelector('[data-builder-price]');
  const summaryEl = builder.querySelector('[data-builder-summary]');
  const cta = builder.querySelector('[data-builder-cta]');
  const productDataElement = builder.querySelector('[data-builder-product]');
  let productData = { url: cta.getAttribute('href'), priceMin: 0, currency: 'USD', variants: [] };
  try {
    productData = JSON.parse(productDataElement?.textContent || '{}');
  } catch (error) {
    console.warn('Bigfoot canopy pricing data could not be read.', error);
  }
  const productUrl = productData.url || cta.getAttribute('href') || '/products/10-x-10-custom-canopy';

  function money(value, currency) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(value);
  }

  function selectedVariant(size, walls) {
    return productData.variants.find((variant) =>
      variant.options?.[0] === size &&
      variant.options?.[1] === walls &&
      (variant.options?.[2] === 'Single' || !variant.options?.[2])
    ) || productData.variants.find((variant) =>
      variant.options?.[0] === size && variant.options?.[1] === walls
    );
  }

  function updateBuilder() {
    const size = sizeInput.value;
    const walls = wallsInput.value;
    const variant = selectedVariant(size, walls);
    const priceInCents = Number(variant?.price ?? productData.priceMin ?? 0);
    priceEl.textContent = money(priceInCents / 100, productData.currency || 'USD');
    summaryEl.textContent = `${size}, ${walls.toLowerCase()}`;

    const params = new URLSearchParams();
    params.set('size', size);
    params.set('walls', walls);
    params.set('artwork', artworkInput.value);
    if (variant?.id) params.set('variant', variant.id);
    cta.href = `${productUrl}?${params.toString()}`;
  }

  [sizeInput, wallsInput, artworkInput].forEach((input) => {
    input.addEventListener('change', updateBuilder);
    input.addEventListener('input', updateBuilder);
  });

  updateBuilder();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const builders = document.querySelectorAll('[data-hero-builder]');
  if (!builders.length) return;

  function money(value, currency) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(value);
  }

  builders.forEach((builder) => {
    const sizeInput = builder.querySelector('[data-hero-builder-size]');
    const wallsInput = builder.querySelector('[data-hero-builder-walls]');
    const artworkInput = builder.querySelector('[data-hero-builder-artwork]');
    const priceEl = builder.querySelector('[data-hero-builder-price]');
    const summaryEl = builder.querySelector('[data-hero-builder-summary]');
    const cta = builder.querySelector('[data-hero-builder-cta]');
    const productDataElement = builder.querySelector('[data-hero-builder-product]');
    let productData = { url: cta.getAttribute('href'), priceMin: 0, currency: 'USD', variants: [] };
    try {
      productData = JSON.parse(productDataElement?.textContent || '{}');
    } catch (error) {
      console.warn('Bigfoot canopy pricing data could not be read.', error);
    }
    const productUrl = productData.url || cta.getAttribute('href') || '/products/10-x-10-custom-canopy';

    function selectedVariant(size, walls) {
      return productData.variants.find((variant) =>
        variant.options?.[0] === size &&
        variant.options?.[1] === walls &&
        (variant.options?.[2] === 'Single' || !variant.options?.[2])
      ) || productData.variants.find((variant) =>
        variant.options?.[0] === size && variant.options?.[1] === walls
      );
    }

    function updateBuilder() {
      const size = sizeInput.value;
      const walls = wallsInput.value;
      const variant = selectedVariant(size, walls);
      const priceInCents = Number(variant?.price ?? productData.priceMin ?? 0);
      priceEl.textContent = money(priceInCents / 100, productData.currency || 'USD');
      summaryEl.textContent = `${size}, ${walls.toLowerCase()}`;

      const params = new URLSearchParams();
      params.set('size', size);
      params.set('walls', walls);
      params.set('artwork', artworkInput.value);
      if (variant?.id) params.set('variant', variant.id);
      cta.href = `${productUrl}?${params.toString()}`;
    }

    [sizeInput, wallsInput, artworkInput].forEach((input) => {
      input.addEventListener('change', updateBuilder);
      input.addEventListener('input', updateBuilder);
    });

    updateBuilder();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-main__thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const id = thumb.dataset.thumbId;
      const section = thumb.closest('.product-main');
      section.querySelectorAll('.product-main__thumb').forEach(t => t.classList.remove('is-active'));
      section.querySelectorAll('.product-main__media-item').forEach(m => m.classList.remove('is-active'));
      thumb.classList.add('is-active');
      section.querySelector(`[data-media-id="${id}"]`).classList.add('is-active');
    });
  });

  const productMain = document.querySelector('.product-main');
  const productForm = productMain?.querySelector('.product-main__form');
  const variantInput = productForm?.querySelector('input[name="id"]');
  const variantData = productMain?.querySelector('[data-product-variants]');
  const variants = variantData ? JSON.parse(variantData.textContent || '[]') : [];
  const priceCurrent = productMain?.querySelector('.product-main__price-current');
  const priceCompare = productMain?.querySelector('.product-main__price-compare');
  const priceSave = productMain?.querySelector('.product-main__price-save');
  const mainAtc = document.querySelector('[data-main-atc]');
  const buyNow = document.querySelector('[data-buy-now]');
  const stickyPrice = document.querySelector('.product-sticky__price');
  const stickyButton = document.querySelector('[data-sticky-atc]');

  function normalizeOption(value) {
    return (value || '').toString().trim().toLowerCase().replace(/\s+/g, ' ');
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format((cents || 0) / 100);
  }

  function syncOptionState(input) {
    const fieldset = input.closest('fieldset');
    if (!fieldset) return;

    fieldset.querySelectorAll('.product-main__option-value').forEach(value => value.classList.remove('is-active'));
    input.parentElement.classList.add('is-active');

    const selected = fieldset.querySelector('.product-main__option-selected');
    if (selected) selected.textContent = input.value;
  }

  function selectedOptions() {
    return Array.from(document.querySelectorAll('.product-main__option')).map((fieldset) => {
      return fieldset.querySelector('input:checked')?.value || '';
    });
  }

  function selectedVariant() {
    const selected = selectedOptions();
    if (!selected.length || !variants.length) return null;

    return variants.find((variant) => {
      return variant.options.every((option, index) => normalizeOption(option) === normalizeOption(selected[index]));
    });
  }

  function updateVariantMedia(variant) {
    const mediaId = variant.featured_media?.id;
    if (!mediaId || !productMain) return;

    const target = productMain.querySelector(`[data-media-id="${mediaId}"]`);
    if (!target) return;

    productMain.querySelectorAll('.product-main__media-item').forEach(item => {
      const active = item === target;
      item.classList.toggle('is-active', active);
      if (!active) item.querySelectorAll('video').forEach(video => video.pause());
    });
    productMain.querySelectorAll('.product-main__thumb').forEach(thumb => {
      thumb.classList.toggle('is-active', thumb.dataset.thumbId === String(mediaId));
    });
  }

  function updateVariantState() {
    const variant = selectedVariant();
    if (!variant) return;

    if (variantInput) variantInput.value = variant.id;
    updateVariantMedia(variant);

    if (priceCurrent) priceCurrent.textContent = formatMoney(variant.price);
    if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

    if (priceCompare) {
      priceCompare.textContent = variant.compare_at_price && variant.compare_at_price > variant.price
        ? formatMoney(variant.compare_at_price)
        : '';
      priceCompare.style.display = priceCompare.textContent ? '' : 'none';
    }

    if (priceSave) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceSave.textContent = `Save ${formatMoney(variant.compare_at_price - variant.price)}`;
        priceSave.style.display = '';
      } else {
        priceSave.textContent = '';
        priceSave.style.display = 'none';
      }
    }

    if (mainAtc) {
      mainAtc.disabled = !variant.available;
      mainAtc.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }

    if (buyNow) {
      buyNow.disabled = !variant.available;
      buyNow.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }

    if (stickyButton) {
      stickyButton.disabled = !variant.available;
      stickyButton.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }
  }

  function selectOptionByValue(optionKeywords, value) {
    if (!value) return false;

    const fieldsets = Array.from(document.querySelectorAll('.product-main__option'));
    const keywordMatch = fieldsets.find((fieldset) => {
      const optionName = normalizeOption(fieldset.dataset.optionName);
      return optionKeywords.some((keyword) => optionName.includes(keyword));
    });

    const possibleFieldsets = keywordMatch ? [keywordMatch] : fieldsets;
    const exactMatches = possibleFieldsets.flatMap((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input[type="radio"]')).filter((input) => {
        return normalizeOption(input.value) === normalizeOption(value);
      });
    });

    const input = exactMatches[0];
    if (!input) return false;

    input.checked = true;
    syncOptionState(input);
    return true;
  }

  function saveConfiguratorArtwork(value) {
    if (!value || !productForm) return;

    let property = productForm.querySelector('[data-configurator-artwork-property]');
    if (!property) {
      property = document.createElement('input');
      property.type = 'hidden';
      property.name = 'properties[Artwork starting point]';
      property.setAttribute('data-configurator-artwork-property', 'true');
      productForm.appendChild(property);
    }

    property.value = value;
  }

  function applyConfiguratorParams() {
    const params = new URLSearchParams(window.location.search);
    const size = params.get('size');
    const walls = params.get('walls');
    const artwork = params.get('artwork');

    selectOptionByValue(['size'], size);
    selectOptionByValue(['wall', 'walls'], walls);
    selectOptionByValue(['art', 'artwork', 'design'], artwork);
    saveConfiguratorArtwork(artwork);
    updateVariantState();
  }

  document.querySelectorAll('.product-main__option-value input').forEach(input => {
    input.addEventListener('change', (e) => {
      syncOptionState(e.target);
      updateVariantState();
    });
  });

  const artworkSelect = document.querySelector('[data-artwork-select]');
  const artworkNote = document.querySelector('[data-artwork-note]');
  const artworkPlan = document.querySelector('[data-artwork-plan]');
  if (artworkSelect && artworkNote && productForm) {
    const artworkNotes = {
      after: artworkPlan?.dataset.noteAfter || '',
      ready: artworkPlan?.dataset.noteReady || '',
      help: artworkPlan?.dataset.noteHelp || ''
    };

    function findArtworkUploadElements() {
      const elements = new Set();
      const fileInput = productForm.querySelector('input[type="file"]');

      if (fileInput) {
        elements.add(fileInput.closest('div, fieldset, p') || fileInput.parentElement || fileInput);
      }

      Array.from(productForm.querySelectorAll('label, p')).forEach((element) => {
        const text = (element.textContent || '').trim().toLowerCase();
        if (!text.includes('upload a file')) return;

        elements.add(element);
        if (element.nextElementSibling) elements.add(element.nextElementSibling);
      });

      return Array.from(elements).filter((element) => element);
    }

    function syncArtworkUpload(mode) {
      const showUpload = mode === 'ready';
      findArtworkUploadElements().forEach((element) => {
        element.classList.add('product-main__file-upload-soft');
        element.hidden = !showUpload;
        element.setAttribute('aria-hidden', showUpload ? 'false' : 'true');

        element.querySelectorAll('button, [role="button"], label, .button, input[type="button"]').forEach((control) => {
          const controlText = ((control.value || control.textContent || '') + '').trim().toLowerCase();
          control.classList.remove('product-main__file-primary-action', 'product-main__file-action-link');

          if (controlText === 'cancel' || controlText === 'remove') {
            control.classList.add('product-main__file-action-link');
            return;
          }

          if (controlText.includes('choose file') || controlText.includes('change file')) {
            control.classList.add('product-main__file-primary-action');
          }
        });
      });
      softenInjectedUploadButtons();
    }

    function softenInjectedUploadButtons() {
      const uploadButtons = Array.from(document.querySelectorAll([
        '.photouploadapp .uploadcare--widget__button',
        '.photouploadapp .uploadcare--widget__button_type_open',
        '[id^="selBtn_"] .uploadcare--widget__button',
        '[id^="selBtn_"] button'
      ].join(',')));

      uploadButtons.forEach((button) => {
        const productScope = button.closest('.product-main, .photouploadapp, [id^="selBtn_"]');
        if (!productScope) return;

        const text = ((button.value || button.textContent || '') + '').trim().toLowerCase();
        if (text === 'cancel' || text === 'remove') {
          button.classList.remove('product-main__file-primary-action');
          button.classList.add('product-main__file-action-link');
          button.style.setProperty('width', 'auto', 'important');
          button.style.setProperty('min-width', '0', 'important');
          button.style.setProperty('min-height', '0', 'important');
          button.style.setProperty('display', 'inline-flex', 'important');
          button.style.setProperty('margin', '0.35rem 0.9rem 0 0', 'important');
          button.style.setProperty('padding', '0', 'important');
          button.style.setProperty('border', '0', 'important');
          button.style.setProperty('border-radius', '0', 'important');
          button.style.setProperty('background', 'transparent', 'important');
          button.style.setProperty('color', '#68717b', 'important');
          button.style.setProperty('-webkit-text-fill-color', '#68717b', 'important');
          button.style.setProperty('font-size', '0.98rem', 'important');
          button.style.setProperty('font-weight', '700', 'important');
          button.style.setProperty('line-height', '1.35', 'important');
          button.style.setProperty('text-decoration', 'underline', 'important');
          button.style.setProperty('text-underline-offset', '3px', 'important');
          button.style.setProperty('text-shadow', 'none', 'important');
          button.style.setProperty('box-shadow', 'none', 'important');
          return;
        }

        if (text && !/(choose|change|select|upload|file)/.test(text)) return;

        button.classList.remove('product-main__file-action-link');
        button.classList.add('product-main__file-primary-action');
        button.style.setProperty('width', '100%', 'important');
        button.style.setProperty('max-width', '100%', 'important');
        button.style.setProperty('display', 'inline-flex', 'important');
        button.style.setProperty('align-items', 'center', 'important');
        button.style.setProperty('justify-content', 'center', 'important');
        button.style.setProperty('border', '1.5px solid #cfd5dc', 'important');
        button.style.setProperty('border-radius', '6px', 'important');
        button.style.setProperty('background', '#fff', 'important');
        button.style.setProperty('color', '#1a1a1a', 'important');
        button.style.setProperty('-webkit-text-fill-color', '#1a1a1a', 'important');
        button.style.setProperty('padding', '1rem', 'important');
        button.style.setProperty('font-size', '1.16rem', 'important');
        button.style.setProperty('font-weight', '700', 'important');
        button.style.setProperty('line-height', '1.2', 'important');
        button.style.setProperty('text-shadow', 'none', 'important');
        button.style.setProperty('box-shadow', 'none', 'important');
      });
    }

    function syncArtworkPlan() {
      const mode = artworkSelect.selectedOptions[0]?.dataset.artworkMode || 'after';
      artworkNote.textContent = artworkNotes[mode] || artworkNotes.after;
      productForm.classList.toggle('is-artwork-ready', mode === 'ready');
      syncArtworkUpload(mode);
    }

    artworkSelect.addEventListener('change', syncArtworkPlan);
    syncArtworkPlan();

    const uploadObserver = new MutationObserver(() => {
      window.requestAnimationFrame(syncArtworkPlan);
    });
    uploadObserver.observe(productForm, { childList: true, subtree: true });

    const uploadAppObserver = new MutationObserver(() => {
      window.requestAnimationFrame(softenInjectedUploadButtons);
    });
    uploadAppObserver.observe(document.body, { childList: true, subtree: true });

    let uploadStylePasses = 0;
    const uploadStyleInterval = window.setInterval(() => {
      softenInjectedUploadButtons();
      uploadStylePasses += 1;
      if (uploadStylePasses > 80) window.clearInterval(uploadStyleInterval);
    }, 250);
  }

  applyConfiguratorParams();

  const cutoffHour = 17;
  const turnaroundDays = 7;
  function updateUrgency() {
    const countdown = document.querySelector('[data-urgency-countdown]');
    const shipdate = document.querySelector('[data-urgency-shipdate]');
    if (!countdown || !shipdate) return;
    const now = new Date();
    const cutoff = new Date();
    cutoff.setHours(cutoffHour, 0, 0, 0);
    let pastCutoff = false;
    if (now > cutoff) { cutoff.setDate(cutoff.getDate() + 1); pastCutoff = true; }
    const diff = cutoff - now;
    const hours = Math.floor(diff / 3600000);
    const mins = Math.floor((diff % 3600000) / 60000);
    countdown.textContent = `${hours}h ${mins}m`;
    const ship = new Date();
    ship.setDate(ship.getDate() + turnaroundDays + (pastCutoff ? 1 : 0));
    shipdate.textContent = ship.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' });
  }
  updateUrgency();
  setInterval(updateUrgency, 60000);

  const stickyBar = document.querySelector('[data-sticky-bar]');
  if (stickyBar && mainAtc) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) stickyBar.classList.remove('is-visible');
        else stickyBar.classList.add('is-visible');
      });
    }, { threshold: 0, rootMargin: '0px 0px -100px 0px' });
    observer.observe(mainAtc);
  }
  const stickyAtcBtn = document.querySelector('[data-sticky-atc]');
  if (stickyAtcBtn && mainAtc) {
    stickyAtcBtn.addEventListener('click', () => {
      mainAtc.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
